<template>
  <div
    v-if="showProgress"
    class="loading-progress-bar"
  >
    <div
      class="progress-bar__line"
      :style="[{transform:`scale(${_rate}, 1)`},{'background-color':color}]"
    />
  </div>
</template>
<script>
export default {
  name: "LoadingProgressBar",
  props: {
    rate: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: "#0585d3",
    },
    isloading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    progressBarRate: 0,
    showProgress: false,
  }),
  computed: {
    _rate() {
      return this.progressBarRate / 100;
    },
  },
  watch: {
    isloading() {
      if (this.isloading) {
        this.$_onProgressStart();
      } else {
        this.$_onProgressEnd();
      }
    },
  },
  methods: {
    $_onProgressStart() {
      // Start
      this.showProgress = true;
      this.progressBarRate = 10;
      // Step 1 complete
      setTimeout(() => {
        if (this.isloading) {
          this.progressBarRate = 50;
        }
      }, 500);

      // Step 2 complete
      setTimeout(() => {
        if (this.isloading) {
          this.progressBarRate = 80;
        }
      }, 900);
    },
    $_onProgressEnd() {
      this.progressBarRate = 100;
      setTimeout(() => {
        this.showProgress = false;
        this.$emit("completed");
      }, 350);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/loading-progress-bar";
</style>